import { render } from "./GameArea.vue?vue&type=template&id=0aaf03dc&scoped=true"
import script from "./GameArea.vue?vue&type=script&lang=js"
export * from "./GameArea.vue?vue&type=script&lang=js"

import "./GameArea.vue?vue&type=style&index=0&id=0aaf03dc&scoped=true&lang=css"

import exportComponent from "/home/josh/git/crackle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaf03dc"]])

export default __exports__